var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"omapi-campaign-table__mods omapi-campaign-table__mods--search"},[_c('campaigns-search-button')],1),_c('div',{staticClass:"omapi-campaign-table__mods"},[_c('campaigns-table-dropdown-filters'),_c('campaigns-table-pagination')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }